<template :pageData="pageData">
  <div class="page-wrapper">
    <div class="header">
      <div class="title">Laptop EFI</div>
      <a href="https://github.com/xzhih/hackintosh-list" class="submit">Submit</a>
    </div>
    <div class="brand" v-for="(brand, key, index) in pageData.Laptop" :key="index">
      <div class="brand-name">{{ key }}<span>{{ brand.length }}</span></div>
      <div class="wrapper">
        <div class="card shadow" v-for="(items, index) in brand" :key="index">
          <div class="model">{{ items.Device }}</div>
          <div class="details">
            <li>CPU：{{ items.CPU }}</li>
            <li>声卡：{{ items.Audio }}</li>
            <li>OS：&nbsp; {{ items.OS }}</li>
          </div>
          <div class="card-bottom">
            <div class="author">
              <span>{{ items.Author.substr(0,1).toUpperCase() }}</span>
              {{ items.Author }}
            </div>
            <a class="get-btn" :href="items.Link" target="_blank" title="get efi">
              <img src="../static/icons/download.svg" alt="download">
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Laptop',
    props: ['pageData']
  }
</script>

<style src="../assets/EFI.css"></style>
